import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL, PASSWORD, USERNAME } from "../../constants";
import { Link, useParams } from "react-router-dom";
import Header from "../Layouts/Header";
import { getApiAction, getSiteId } from "../../Utils/helper";
import { useDispatch } from "react-redux";
import { BASE_URL } from '../../constants';

const SubCategoryMenu = () => {
  const { id: group } = useParams();
  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/menu_Bg.png)`,
  };

  const [responseData, setResponseData] = useState(null);
  const dispatch = useDispatch();


  useEffect(() => {
    return () => {
      const fetchData = async () => {
        try {
          let response = await getApiAction("products/categories?subgroup="+group,'', 0,dispatch);
          setResponseData(response);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    };
  }, []);

  return (
    <div>
      <div className="wrapper">
        <div className="category_wrapper category_wrapperBg_image" style={bannerStyle}>
          <Header />

          {/* START category_ContentArea */}
          <div className="category_ContentArea">
            <div className="container">
              <h2>
                {group}
              </h2>
              {responseData?.categories &&
                Object.entries(responseData?.categories).map(
                  ([categoryName, categoryItem]) => (
                    <>
                      <div className="itenBox">
                        <h3>{categoryName }</h3>
                        <div className="row">
                          {categoryItem &&
                            Object.entries(categoryItem).map(
                              ([index, _item]) => (
                                <>
                              {(index !== 'Single') ? ( 
                                <>
                                  {_item.map((item) => (
                                    <div className="col-sm-6 col-md-4 item">
                                      <div className="image">
                                        <Link to={`/${getSiteId()}/product/${item.name}`}>
                                          <img
                                            src={item.default_image}
                                            alt=""
                                          />
                                          {/* <img src={item.default_image} alt="" /> */}
                                        </Link>
                                      </div>
                                      <h4>
                                        <Link to={`/${getSiteId()}/product/${item.name}`}>
                                          {item.name}
                                        </Link>
                                      </h4>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <>
                                </>
                              )}
                              </>
                            ))}
                        </div>
                      </div>
                    </>
                  )
                )}
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryMenu;
